import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

import { selectActiveAddOnSubscriptions, selectActivePlanSubscription } from '../../queries/selectors/products';
import { selectClient } from '../../global-selectors';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { getSelectedPlan, getSelectedPPV } from '../../queries/selectors/shoppingCart';
import { selectIsBuySubscriptions, selectLatestSubscription } from '../../queries/selectors/bootstrap';
import { isMobile } from 'react-device-detect';
import isWebview from 'is-ua-webview';
import { ProductType } from '../../enums';
import { PaymentMethods } from '../../enums';


export const withMembershipGuard = (WrappedComponent) => (props) => {
  // TODO: ajustar el wrapper para que funcione con el nuevo flujo de affilates
  const Wrapper = ({
    selectedSubscriptionToBuy,
    paymentMethod,
    client,
    activeSubscription,
    isBuySubscriptions,
    addOnsSubscription,
    selectedPPVToBuy,
    latestSubscription,
    ...props
  }) => {
    const { location } = props;
    const path = location.pathname;
    const isMyAccount = path.includes('myaccount');
    const isPaymentMethods = path.includes('payment-methods');
    const isPaymentPath = path.includes('payment') && !isPaymentMethods;
    const allowStayInMyaccount = ['deleteAccount', 'general', 'payment-methods', 'new-payment-method', 'invoices']
      .some((tab) => path.includes(tab));
    const hasInvalidActiveSubscription =
      !activeSubscription ||
      (isPaymentPath && activeSubscription?.productId === ProductType.ACCESS_PLAN_DEFAULT_PRODUCTID && addOnsSubscription?.length) ||
      (activeSubscription.productId === ProductType.ACCESS_PLAN_DEFAULT_PRODUCTID && !isMyAccount && !isPaymentMethods && !addOnsSubscription?.length);
    // Incomm flows ignores subscription validation
    if (paymentMethod === 'incomm') {
      return <WrappedComponent {...props} />;
    }
    const hasLastSubscriptionAsAffiliates = latestSubscription?.purchaseState?.paymentMethod === PaymentMethods.AFFILIATES;
    // TODO: Affiliates flows ignores subscription validation
    if (hasLastSubscriptionAsAffiliates || paymentMethod === PaymentMethods.AFFILIATES) {
      return <WrappedComponent {...props} />;
    }

    // Validate device and send feedback to user if they are with mobile device and without subscription
    if (!activeSubscription && !selectedSubscriptionToBuy && !isBuySubscriptions && isMobile && isWebview(navigator.userAgent)) {
      return <Redirect to={`/${client}/mobile/feedback${location.search}`} />
    }
    
    if (hasInvalidActiveSubscription && !allowStayInMyaccount && !selectedPPVToBuy && !selectedSubscriptionToBuy && !isBuySubscriptions) {
      return <Redirect to={`/${client}/subscribe/plans${location.search}`} />;
    }
    return <WrappedComponent {...props} />;
  };

  Wrapper.propTypes = {
    selectedSubscriptionToBuy: PropTypes.object.isRequired,
    isBuySubscriptions: PropTypes.bool,
    client: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    activeSubscription: PropTypes.string.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
  };

  return Wrapper(props);
};

const mapStateToProps = (state) => ({
  isBuySubscriptions: selectIsBuySubscriptions(state),
  selectedSubscriptionToBuy: getSelectedPlan(state),
  activeSubscription: selectActivePlanSubscription(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  client: selectClient(state),
  addOnsSubscription: selectActiveAddOnSubscriptions(state),
  selectedPPVToBuy: getSelectedPPV(state),
  latestSubscription: selectLatestSubscription(state)
});

const mapDispatchToProps = {
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withMembershipGuard
);
